import Dialog from '@mui/material/Dialog'

import CloseIcon from '@mui/icons-material/Close'
import {
  StyledDiv,
  StyledErrorIcon,
  StyledButton,
  StyledDialogContent,
  StyledIconButton,
  StyledTypography,
  StyledSectionDividerLine
} from '../ProjectDetails/PopupComponent/PopupComponentStyle'
import PopupMessages from '../common/PopupMessages/PopupMessages.json'
import buttonTitles from '../../appConfig/buttonTitles.config.json'
import PropTypes from 'prop-types'

const CancelPopup = ({open, setOpen, setNavigateToAdminPanel, updateCustomizationWithDefaultData}) => {
  const handleClose = () => {
    setOpen(false)
  }

  const handleSelection = () => {
    updateCustomizationWithDefaultData()
    setNavigateToAdminPanel(true)
  }

  const heading = PopupMessages.cancelWarning
  const bodyContent = PopupMessages.cancelBodyExistingProject
  const bodyEnd = PopupMessages.cancelBodyEnd
  const selectionText = PopupMessages.cancelOptionMessage
  const cancelText = 'Cancel'

  return (
    <Dialog maxWidth='xs' open={open}>
      <StyledDialogContent tabIndex={0} aria-label='alert' dividers>
        <StyledIconButton title={buttonTitles.popupNotification} onClick={handleClose} aria-label='close-dialogue'>
          <CloseIcon style={{fontSize: (theme) => theme.typography.h6.fontSize}} />
        </StyledIconButton>
        <StyledSectionDividerLine />
        <StyledDiv hasPadding={true}>
          <StyledErrorIcon />
        </StyledDiv>
        <StyledDiv tabIndex={0} id={heading} textBold={true} hasPadding={true}>
          {heading}
        </StyledDiv>
        <StyledDiv hasPadding={true} />
        <StyledTypography tabIndex={0} id={bodyContent} gutterBottom>
          {bodyContent}
          <StyledDiv hasPadding={true}>{bodyEnd}</StyledDiv>
        </StyledTypography>
        <StyledDiv hasPadding={true}>
          <StyledButton onClick={handleSelection}>{selectionText}</StyledButton>
        </StyledDiv>
        <StyledDiv>
          <StyledButton isCancelButton={true} onClick={handleClose}>
            {cancelText}
          </StyledButton>
        </StyledDiv>
      </StyledDialogContent>
    </Dialog>
  )
}

CancelPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setNavigateToAdminPanel: PropTypes.func.isRequired,
  updateCustomizationWithDefaultData: PropTypes.func.isRequired
}

export default CancelPopup
